import React from 'react';

import { Button, Typography } from 'antd';

interface Props {
  options: {
    icon: React.ReactNode;
    label: string;
    backgroundColor?: string;
    onClick: () => void;
  }[];
  title?: string;
  noBorder?: boolean;
}

const CreateCommunityPostAttachment: React.FC<Props> = ({
  options,
  // title = 'Add to your post',
  noBorder,
}) => {
  return (
    <div
      className={`createpost__attachment__container ${
        noBorder ? 'borderless' : ''
      } add_redius`}>
      <div
        className="createpost__attachment__options"
        style={
          options?.length >= 4
            ? { justifyContent: 'space-between' }
            : { justifyContent: 'flex-start' }
        }>
        {options.map((option, index) => (
          <div key={index} className="createpost__attachment__option">
            <Button
              className="createpost__attachment__option__icon"
              style={
                option.backgroundColor
                  ? { backgroundColor: option.backgroundColor }
                  : {}
              }
              onClick={option.onClick}>
              {option.icon}
            </Button>
            <Typography.Text className="createpost__attachment__option__label">
              {option.label}
            </Typography.Text>
          </div>
        ))}
      </div>
    </div>
  );
};

export default React.memo(CreateCommunityPostAttachment);
